<div class="fixed-section">
    <section class="titleBarBg fixed-top">
        <div class="container-fluid">
            <div class="row mar-7px">
                <div class="w-3">
                    <img src="./assets/images/manage_adhoc.png" class="pageIcon" alt=""
                        style="width: 36px;padding: 8px;" />
                </div>
                <div class="w-97">
                    <div class="pageHeadingBar">
                        <div class="row">
                            <div class="col-md-6 align-self-center">
                                <h6 class="pageHeadingText mb-0 text-uppercase">AD HOC List</h6>
                            </div>

                            <div class="col-md-3 align-self-center">

                            </div>
                            <div class="col-md-3 align-self-center text-end">
                                <ul class="list-inline mb-0">
                                    <li class="list-inline-item">
                                        <img src="assets/images/export.png" class="me-1 w-25px pointerCursor" alt=""
                                            title="Export" (click)="ExportSalesplanData()">
                                    </li>
                                    <!-- <li class="list-inline-item">
                                        <div class="nav-item dropdown">
                                            <a class="nav-link dropdown-toggle urserName" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="assets/images/filter.png" class="w-20px me-2" alt="" title="Filter">

                                            </a>
                                            <ul class="dropdown-menu customMargindrp w-300">
                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>CATEGORY</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <p-multiSelect [options]="categoryFilterList" [(ngModel)]="categoryDropdown" (ngModelChange)="onSelectedCategoryDropdown($event)" name="category" [showHeader]="true"
                                                            [filter]="true" placeholder="Select Category" (click)="stopPropagation($event)">
                                                            <ng-template pTemplate="header">
                                                                <div class="custom-multiselect-header">
                                                                    <span style="padding-right: 5px;">SELECT ALL</span>
                                                                </div>
                                                            </ng-template>
                                                        </p-multiSelect>
                                                    </div>
                                                </div>
                                                <div class="row ">
                                                    <div class="offset-md-5 col-md-7 ps-0">
                                                        
                                                            <button class="btn progressBtn w-100" role="button" (click)="applyCategoryDropdown()">
                                                                APPLY FILTER
                                                            </button>
                                                    </div>
                                                </div>


                                            </ul>
                                        </div>
                                    </li> -->
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>


</div>

<div class="middleContent mt-131">
    <section style="margin-top: 131px;">
        <div class="container-fluid px-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="card border-0 stepsBars-2 mb-5">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-1 align-self-center">
                                    <h6 class="loginHeadingText text-start mb-0">SEARCH BY</h6>
                                </div>
                                <div class="col-md-4">
                                    <div class="d-flex w-100">
                                        <div class="align-self-center me-3 w-25 text-end">
                                            <label for="">AD HOC TITLE</label>
                                        </div>
                                        <div class="w-75 position-relative pe-4">
                                            <input type="text" class="form-control" placeholder="Project Title"
                                                [(ngModel)]="searchedProjectTiltle"
                                                (keyup)="onProjectTitleChange($event)">
                                            <img src="assets/images/magnifying-glass.png" class="glassIcon" alt="">
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-2 pe-0">
                                    <div class="d-flex">
                                        <div class="align-self-center me-3 w-25 text-end">
                                            <label for="">CATEGORY</label>
                                        </div>
                                        <div class="w-75">
                                            <p-multiSelect  name="category" [showHeader]="true" [filter]="true"
                                                placeholder="Select Category" optionLabel="categoryName" 
                                                >
                                                <ng-template let-category pTemplate="item">
                                                    <div class="hover-item" title="{{category.categoryName}}">
                                                        {{ category.categoryName }}
                                                    </div>
                                                </ng-template>
                                            </p-multiSelect>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-md-2 pe-0">
                                    <div class="d-flex">
                                        <div class="align-self-center me-3 w-25 text-end">
                                            <label for="">CATEGORY</label>
                                        </div>
                                        <div class="w-75">
                                            <p-multiSelect [options]="categoryList"
                                                [(ngModel)]="selectedCategoriesFilter"
                                                (ngModelChange)="onSelectedCategory($event)" name="category"
                                                [showHeader]="true" [filter]="true" placeholder="Select Category"
                                                optionLabel="categoryName">
                                                <ng-template let-category pTemplate="item">
                                                    <div class="hover-item" title="{{category.categoryName}}">
                                                        {{ category.categoryName }}
                                                    </div>
                                                </ng-template>
                                            </p-multiSelect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="d-flex">
                                        <div class="align-self-center me-3 w-50 text-end">
                                            <label for="">STARTED BEWTEEN</label>
                                        </div>
                                        <div class="w-75">
                                            <p-calendar name="dateCalendar" dateFormat="dd-M-yy"
                                                [(ngModel)]="selectedDateRange" (click)="stopPropagation($event)"
                                                (ngModelChange)="selectedSubmittedDateRange()"
                                                styleClass="custom-calendar-width" selectionMode="range">
                                            </p-calendar>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <table class="table datatable border-x-0 mb-0"
                                        *ngIf="adHocList && adHocList.length > 0">
                                        <thead>
                                            <tr class="subheaderrr">
                                                <th width="20%" colspan="2" class="project" rowspan="2">
                                                    AD HOC TITLE
                                                </th>
                                                <th width="30%" rowspan="2">
                                                    CATEGORY
                                                </th>
                                                <th width="6%" rowspan="2">
                                                    DATE
                                                </th>
                                                <th width="20%" rowspan="2">
                                                    AD HOC QUESTION COUNT
                                                </th>
                                                <!-- <th width="6%" rowspan="2">
                                                    Ad Hoc Priority Items Count
                                                </th>
                                                <th width="6%" rowspan="2">
                                                    Ad Hoc Priority Brands Count
                                                </th> -->
                                                <th colspan="2">
                                                    AD HOC STOCKING PRIORITY COUNT
                                                </th>
                                            </tr>
                                            <tr class="subheaderrr">
                                                <th class="subtdBg">ITEMS</th>
                                                <th class="subtdBg">BRANDS</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <ng-container *ngFor="let proj of adHocList; let i = index">
                                                <tr>
                                                    <td width="2%" class="vertical-align-middle text-center titleTdBg">
                                                        <img src="assets/images/pencilIocn.svg"
                                                            class="me-1 w-21 pointerCursor" alt="" title="Edit"
                                                            (click)="editAdhocList(proj.adHocRequestId)">
                                                    </td>
                                                    <td class="text-center vertical-align-middle"
                                                        [attr.rowspan]="proj.projectFilesCount">
                                                        {{proj.title}}
                                                    </td>
                                                    <td class="text-center vertical-align-middle"
                                                        [attr.rowspan]="proj.projectFilesCount">
                                                        {{categoryNames[i]?.categories}}
                                                    </td>
                                                    <td class="text-center vertical-align-middle"
                                                        [attr.rowspan]="proj.projectFilesCount">
                                                        {{ proj.createdDate | date:'dd-MMM-yyyy' }}
                                                    </td>
                                                    <td class="text-center vertical-align-middle"
                                                        [attr.rowspan]="proj.projectFilesCount">
                                                        {{ proj.adHocQuestionCount }}
                                                    </td>
                                                    <td class="text-center vertical-align-middle"
                                                        [attr.rowspan]="proj.projectFilesCount">
                                                        {{ proj.adHocPriorityCount }}
                                                    </td>
                                                    <td class="text-center vertical-align-middle"
                                                        [attr.rowspan]="proj.projectFilesCount">
                                                        {{ proj.adHocPriorityBrandCount }}
                                                    </td>
                                            </ng-container>
                                        </tbody>

                                    </table>
                                    <div class="card" *ngIf="adHocList?.length === 0 ">
                                        <div class="card-body py-2 px-3">
                                            <div class="emtyCard p-0">
                                                <p class="mb-0">At this moment there are no Ad Hoc in the system.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<p-confirmDialog position="top" [baseZIndex]="200000" appendTo="body" role="alertdialog"></p-confirmDialog>